<template>
    <footer>
        <div class="address">
            <div class="data">
                <div class="item">
                    <div class="icon iconfont icon-kefu"></div>
                    <div class="icon-label">H7 * 12 客服服务</div>
                </div>
                <div class="item">
                    <div class="icon iconfont icon-zhuanye"></div>
                    <div class="icon-label">T10+ 专业团队</div>
                </div>
                <div class="item">
                    <div class="icon iconfont icon-anquan"></div>
                    <div class="icon-label">L2+ 数据安全保护</div>
                </div>
                <div class="item">
                    <div class="icon iconfont icon-xinhao"></div>
                    <div class="icon-label">S4+ 信号加密</div>
                </div>
                <div class="item">
                    <div class="icon iconfont icon-wending"></div>
                    <div class="icon-label">D365+ 稳定不宕机</div>
                </div>
            </div>
        </div>
        <div class="company">
            <div>Copyright © 2021 Zonelink All Rights Reserved.</div>
            <a href="https://beian.miit.gov.cn" target="_blank" style="color: #a3a3a3;">粤ICP备2021134867号</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009867" target="_blank"
                class="gongan-div"><img :src="gongan" />
                <p>粤公网安备 44010602009867号</p>
            </a>
        </div>
    </footer>
</template>

<script>

export default {
    name: 'foot',
    data() {
        return {
            src: '/static/img/logo.png',
            gongan: "/static/img/gongan.png"
        }
    }
}
</script>

<style lang='scss'>
footer {
    top: 1000px;
    left: 0;
    height: 140px;
    background: #191919;
}

.address {
    height: 80px;
    font-size: 12px;
    color: #a3a3a3;
    text-align: center;
}

.company {
    border-top: 1px solid #2b2b2b;
    font-size: 12px;
    color: #a3a3a3;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
}

.address img {
    width: 125px;
    height: 72px;
    margin-top: -10px;
    margin-bottom: 30px;
}

.data {
    position: relative;
    top: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.item {
    display: flex;
    align-items: center;
    color: #fff;
}

.item+.item {
    margin-left: 50px;
}

.icon {
    font-size: 24px !important;
}

.icon-label {
    font-size: 16px;
    margin-left: 20px;
}

.link {
    font-size: 12px;
    color: #a3a3a3;
    text-align: center;
    position: relative;
    top: 25%;
}

@mixin img-style {
    display: inline-block;
    width: 24px;
    height: 22px;
}

#github {
    background: url("/static/img/github.png");
    @include img-style;
    margin-right: 35px;
}

#wechat {
    background: url("/static/img/social_icon.png");
    @include img-style;
    background-position: -24px 0;
}

.gongan-div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
}

.gongan-div img {
    height: 20px;
    width: 20px;
    margin-right: 2px;
}

.gongan-div p {
    color: #a3a3a3;
}
</style>



// WEBPACK FOOTER //
// footer.vue?2b6d6f58